module.exports = __webpack_public_path__ + "img/12-5.b20dd9d9.png";